import React from 'react';
import { ColorModeProvider, Preflight } from '@xstyled/styled-components';
import { MDXProvider } from './MDX';
import { GlobalStyle, ThemeProvider } from './Theme';
export function RootWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(ColorModeProvider, null, /*#__PURE__*/React.createElement(Preflight, null), /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(MDXProvider, null, children)));
}